<template>
  <div id="pageItemList">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fulltextSearch')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="faultMessages"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="faultMessagesCount"
                :loading="faultMessageIsLoading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.priority }}</td>
                  <td>{{ props.item.bit_word }}</td>
                  <td>{{ props.item.bit }}</td>
                  <td>
                    <v-btn
                      flat
                      icon
                      color="info"
                      @click="editAction(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      color="red"
                      @click="$refs.deleteDialog.deleteAction(props.item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <fault-message-create-edit-dialog
      v-model="modal"
      @saved="fetchItems"
    ></fault-message-create-edit-dialog>

    <delete-dialog
      messageKey="deleteFaultMessage"
      ref="deleteDialog"
      @confirm="deleteConfirmation"
    ></delete-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_FAULT_MESSAGES,
  FETCH_FAULT_MESSAGE,
  DELETE_FAULT_MESSAGE,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import createButtonMixin from "@/mixins/createButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import FaultMessagesCreateEditDialog from "@/views/FaultMessages/FaultMessagesCreateEditDialog.vue";

export default {
  components: {
    "fault-message-create-edit-dialog": FaultMessagesCreateEditDialog
  },
  data() {
    return {
      modal: {
        show: false,
        mode: ""
      },
      pagination: {
        sortBy: null,
        descending: false
      },
      headers: [
        { text: "#", value: "id" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("priority"), value: "priority" },
        { text: this.$t("bitWord"), value: "bit_word" },
        { text: this.$t("bit"), value: "bit" },
        { text: this.$t("actions"), sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "faultMessages",
      "faultMessagesCount",
      "faultMessage",
      "faultMessageIsLoading",
      "createButton",
      "refreshButton"
    ])
  },
  mixins: [
    refreshButtonMixin,
    createButtonMixin,
    searchInputMixin,
    paginationMixin
  ],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_FAULT_MESSAGES, [
        this.pagination,
        this.search
      ]);
    },
    createAction() {
      this.modal.mode = "create";
      this.modal.show = true;
    },
    editAction(id) {
      this.$store.dispatch(FETCH_FAULT_MESSAGE, id).then(() => {
        this.modal.mode = "edit";
        this.modal.show = true;
      });
    },
    deleteConfirmation(faultMessage) {
      this.$store.dispatch(DELETE_FAULT_MESSAGE, faultMessage.id).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("deletedSuccessfully", [this.$t("faultMessage")]),
          color: "success"
        });

        this.fetchItems();
      });
    }
  }
};
</script>

<style scoped></style>
